import { Dashboard as DashboardComponent } from './Dashboard.component';
import { connector } from './Dashboard.connector';

export const Dashboard = connector(DashboardComponent);
